import dt from 'dayjs'
import * as lib from '../lib'
import {
	type IFetchItems,
	type IFetchOfferSpendByAccount,
	type TFetchOfferSpendByAccountAggregated,
	type TOfferSpendByAccount,
	type TOfferSpendByAccountAggregated,
} from '../types'

export const listOfferSpendByAccount = async (
	filter: ReturnType<typeof lib.filterSetup>,
	sort: ReturnType<typeof lib.sortSetup>,
	skip: ReturnType<typeof lib.skipSetup>,
	take: ReturnType<typeof lib.takeSetup>,
	signal: AbortSignal,
	token?: string | null,
): Promise<IFetchItems<TOfferSpendByAccount>> => {
	const headers = lib.bearer(token)
	const method: string = 'GET'
	const params: lib.FetchOptions['params'] = {
		f: filter,
		s: sort,
		skip,
		take
	}
	const uri: string = 'offer/spend/by/account'

	const options: lib.FetchOptions = {
		headers,
		method,
		params,
		signal,
	}
	const data = await lib.fetching<IFetchItems<IFetchOfferSpendByAccount>>(uri, options)

	const rows = data?.items
		?.map((item: IFetchOfferSpendByAccount): TOfferSpendByAccount => {
			const { ...row } = item
			const result = {
				...row,
				agg: row.agg.map((agg: TFetchOfferSpendByAccountAggregated): TOfferSpendByAccountAggregated => {
					return {
						...agg,
						at: dt.utc(agg.at).toDate(),
						createdAt: dt.utc(agg.createdAt).toDate(),
						updatedAt: dt.utc(agg.updatedAt).toDate(),
						}
				}),
				account: !row?.account ? null : {
					...row.account,
					registeredAt: !!row.account.registeredAt ? dt.utc(row.account.registeredAt).toDate() : null,
					createdAt: dt.utc(row.account.createdAt).toDate(),
					updatedAt: dt.utc(row.account.updatedAt).toDate(),
					deletedAt: !!row.account.deletedAt ? dt.utc(row.account.deletedAt).toDate() : null,
					role: !row.account?.role ? null : {
						...row.account.role,
						createdAt: dt.utc(row.account.role.createdAt).toDate(),
						updatedAt: dt.utc(row.account.role.updatedAt).toDate(),
					},
					auth: !row.account?.auth ? null : {
						...row.account.auth,
						updatedAt: dt.utc(row.account.auth.updatedAt).toDate(),
					}
				}
			}
			return result
		})

	return {
		items: rows ?? [],
		total: data?.total ?? 0,
	}
}
